import React from 'react';
import { IntlProvider } from 'react-intl';
import { defaultLocale, extractValidLocale, locales } from './setup';

const currentLocale = extractValidLocale(navigator.languages || []);
const messages = Object.assign({}, locales.placeholder, locales[currentLocale as keyof typeof locales]);

export const LocaleProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <IntlProvider messages={messages} locale={currentLocale} defaultLocale={defaultLocale}>
      {children}
    </IntlProvider>
  );
};
